<template>
  <v-card>
    <v-card-title class="justify-center">{{ header }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <!-- Date From -->
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="computedDateFromFormatted"
                label="Datum von"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateFrom"
              locale="de-DE"
              scrollable
              :min="minDate"
              :max="dateTo"
              :first-day-of-week="1"
              @input="menuFrom = false"
              @change="filterDate = true"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6">
          <!-- Date To -->
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="computedDateToFormatted"
                label="Datum bis"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateTo"
              locale="de-DE"
              scrollable
              :min="dateFrom"
              :max="new Date().toISOString().substr(0, 10)"
              :first-day-of-week="1"
              @input="menuTo = false"
              @change="filterDate = true"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions class="text-center justify-center">
      <v-btn
        :loading="loading"
        color="primary"
        @click="
          $emit('generate', {
            dateFrom,
            dateTo,
            api,
            apiPayload,
            isXml: false
          })
        "
      >
        CSV Report
      </v-btn>
      <v-btn
        v-if="apiPayload.OutputType"
        :loading="loading"
        color="primary"
        @click="
          $emit('generate', {
            dateFrom,
            dateTo,
            api,
            apiPayload,
            isXml: true
          })
        "
      >
        XML Report
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean
    },
    api: {
      type: String
    },
    apiPayload: {
      type: Object
    }
  },
  data() {
    return {
      minDate: new Date(Date.UTC(2022, 5, 1)).toISOString(),
      dateFrom: new Date(
        Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)
      )
        .toISOString()
        .substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      menuFrom: false,
      menuTo: false
    }
  },
  computed: {
    computedDateFromFormatted() {
      return this.formatDate(this.dateFrom)
    },
    computedDateToFormatted() {
      return this.formatDate(this.dateTo)
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      const [year1, month1, day1] = date.toString().split('-')
      return `${day1}.${month1}.${year1}`
    }
  }
}
</script>
